import React from 'react';
import { Stack, Skeleton } from '@mui/material';
import ProficiencyDotsSkeleton from 'shared/components/proficiencyDotsSkeleton';

interface ICandidateInterviewFeedbackAverageRatingSkeletonProps {}

const CandidateskillRatingskeleton = () => {
  return (
    <Stack
      justifyContent='space-between'
      mb='0.5rem'
      flexDirection='row'
      data-testid='candiadate-interview-feedback-average-rating'
    >
      <Skeleton
        variant='rectangular'
        width='7.125rem'
        height={20}
        sx={{
          bgcolor: (theme) => theme.palette.neutral?.main,
        }}
      />
      <ProficiencyDotsSkeleton />
      <Skeleton
        variant='rectangular'
        width='1.25rem'
        height={20}
        sx={{
          bgcolor: (theme) => theme.palette.neutral?.main,
        }}
      />
    </Stack>
  );
};

const CandidateInterviewFeedbackAverageRatingSkeleton = (
  props: ICandidateInterviewFeedbackAverageRatingSkeletonProps
) => {
  return (
    <>
      {[...Array(6)].map((_, i) => {
        return <CandidateskillRatingskeleton key={i} />;
      })}
    </>
  );
};

export default CandidateInterviewFeedbackAverageRatingSkeleton;
